import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { SessionData } from 'src/app/domain/session-data';
import { URL_DECRYPT_URL_PARAMS } from 'src/app/shared/config-urls';

@Injectable({
  providedIn: 'root'
})
export class DecodeParamsService {

  constructor(private httpService: HttpService) { }

  decryptUrl(sessionData: SessionData, id: string) {
    return this.httpService.post<any>(`${URL_DECRYPT_URL_PARAMS}`, this.getDecryptUrlBody(id), '');
  }

  private getDecryptUrlBody(id: string) {
    return {
      'decrypt_url': {
        'encrypted_url': id
      }
    };
  }
}
